import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { MultiSelectAutoCompleteModel } from './advanced-sample-multiple-select.model';
import { NeqSelectAutocompleteComponent } from '@sharedcommon/components/select-autocomplete/neq-select-autocomplete.component';

@Component({
  selector: 'advanced-sample-multiple-select',
  templateUrl: './advanced-sample-multiple-select.component.html',
})
export class AdvancedSampleMultipleAutocompleteComponent<T> implements OnInit {

  @Input() multiSelectInput: MultiSelectAutoCompleteModel<T>;
  @Input() bindLabel: string;
  /** Input to use in case the dataSource methode is not paginated AND a filter need to be done algorithmically */
  @Input() paginatedResults: boolean = true;
  @Input() disabled: boolean = false;

  @Output() update = new EventEmitter();

  @ViewChild(NeqSelectAutocompleteComponent) select: NeqSelectAutocompleteComponent;


  ngOnInit() {
    this.reset(true, false);
  }

  onChange() {
    this.multiSelectInput.allSelectedValues = this.multiSelectInput.allSelectedValues || [];
    this.update.emit(this.multiSelectInput);
  }

  reset(search = true, resetValue = true) {
    if (this.select) {
      this.select.reset(search, resetValue)
    }
  }

}
